<template>
  <div v-if="links?.length"
      class="p-8 rounded-lg transition-[padding_margin] bg-(--main-color) text-white flex flex-col gap-5 md:flex-row md:gap-18">
    <h2 class="text-xl md:text-2xl font-semibold">{{ title ?? $t('links_to_consult') }}</h2>
    <div class="flex flex-col gap-4">
      <DynamicLink :link="link.link" :label="link.label" v-for="(link, linkIndex) in links" :key="`link-${linkIndex}`" class="font-semibold hover:translate-x-1 transition-[translate]"/>
    </div>
  </div>
</template>

<script lang="ts">
import type {PropType} from 'vue'
import {DynamicLink} from '@/components/small'

export default {
  name: 'LinkList',
  components: {DynamicLink},
  props: {
    links: {
      type: Array as PropType<Link[]>,
      required: true
    },
    title: {
      type: String,
      default: null
    }
  }
}
</script>